import { Component } from '@angular/core';
import { SlideMenuService } from '../../services/slide-menu/slide-menu.service';
import { MenuItem } from '../../models/menu-item.model';
import { MAIN_MENU } from '../../data/items-main-menu.data';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {

  public menu: Array<MenuItem> = MAIN_MENU;

  constructor(
    public slideMenuService: SlideMenuService
  ) { }

}
